export const FILE_DOMAIN = process.env.VUE_APP_FILE_DOMAIN || 'https://mks.yybip.com/'
export const MARKET_DOMAIN = process.env.VUE_APP_MARKET_DOMAIN || 'https://mk.yybip.com/'
export const MOBILE_DOMAIN = process.env.VUE_APP_MOBILE_DOMAIN || 'https://mkm.yybip.com/'
export const CDN_DOMAIN = process.env.VUE_APP_CDN_DOMAIN || 'https://mkfs.yybip.com/'
export const API_DOMAIN = process.env.VUE_APP_API_ROOT || 'https://mk-api.yybip.com/'

export function formatFileUrl(path) {
  if (!path) return ''
  if (/^https?:\/\//.test(path)) return path
  return FILE_DOMAIN + path
}
